import type { ReactNode } from 'react'
import { Button } from './Button'

/** Menampilkan pesan kesalahan dari server TANPA menutupi halaman lain. */
export function ErrorState({
  pesan,
  kode,
  onCoba,
  aksi,
  ringkas = false,
}: {
  pesan: string
  kode?: string | null
  onCoba?: () => void
  aksi?: ReactNode
  ringkas?: boolean
}) {
  const ramah = kode === 'NOT_IMPLEMENTED' || kode === 'HTTP_404'
  return (
    <div
      className={`rounded-xl border border-red-200 bg-red-50 ${ringkas ? 'px-3 py-2' : 'px-4 py-6'}`}
      role="alert"
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-red-800">
            {ramah ? 'Data belum dapat ditampilkan' : 'Gagal memuat data'}
          </p>
          <p className="mt-1 text-sm break-words text-red-700">{pesan}</p>
          {kode ? <p className="mt-1 font-mono text-xs text-red-500">Kode: {kode}</p> : null}
          {ramah ? (
            <p className="mt-1 text-xs text-red-600">
              Endpoint ini belum tersedia pada server. Halaman tetap dapat dipakai untuk modul lain.
            </p>
          ) : null}
        </div>
        <div className="flex items-center gap-2">
          {aksi}
          {onCoba ? (
            <Button varian="garis" ukuran="kecil" onClick={onCoba}>
              Coba lagi
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
